import { createFileRoute, redirect } from '@tanstack/react-router';

import { isWelcomePageEnabled, WelcomePage } from '@/features/welcome';
import { Routes } from '@/types/routes';

export const Route = createFileRoute('/_authenticated/welcome/')({
  loader() {
    if (isWelcomePageEnabled()) {
      return;
    }

    throw redirect({
      to: Routes.Chats as string,
      replace: true,
    });
  },
  component: WelcomePage,
});
